import { render, staticRenderFns } from "./Tickers.vue?vue&type=template&id=b60cac72&scoped=true"
import script from "./Tickers.vue?vue&type=script&lang=js"
export * from "./Tickers.vue?vue&type=script&lang=js"
import style0 from "./Tickers.vue?vue&type=style&index=0&id=b60cac72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60cac72",
  null
  
)

export default component.exports